module.exports = __webpack_public_path__ + "img/W-G28.16b3166b.jpg";